import { createColDef } from '@fortem-monorepo/react-ag'

import { CounterpartyIdCellEditor } from '@/ag-grid/columns/counterparty-id/cell-editor'
import { CounterpartyIdCellRenderer } from '@/ag-grid/columns/counterparty-id/renderer'

export const counterparty_id = createColDef<{ counterparty_id: number | null }>({
  field: 'counterparty_id',
  headerName: 'Counterparty',
  cellRenderer: CounterpartyIdCellRenderer,
  cellEditor: CounterpartyIdCellEditor,
  width: 200,
})
